package link.erpango.quip.data.remote.repository.auth

import kotlinx.serialization.builtins.serializer
import link.erpango.quip.data.remote.ApiClient
import link.erpango.quip.data.remote.DResponse
import link.erpango.quip.data.remote.repository.IApiRepository
import link.erpango.quip.domain.entities.DGoogleLoginRequest
import link.erpango.quip.domain.entities.DLoginRequest
import link.erpango.quip.domain.entities.DAuth
import link.erpango.quip.domain.entities.DRefreshRequest

class AuthRepository(
    override val api: ApiClient,
): IAuthRepository, IApiRepository<ApiClient> {
    override val resourcePath: String
        get() = "api/auth"

    override suspend fun login(user: String, pass: String): DResponse<DAuth> {
        return this.api.consume("$resourcePath/login/")
            .post(DLoginRequest(user, pass), DLoginRequest.serializer())
            .response(DAuth.serializer())
    }

    override suspend fun loginWithGoogle(idToken: String): DResponse<DAuth> {
        return this.api.consume("$resourcePath/login/googlesignin/")
            .post(DGoogleLoginRequest(idToken), DGoogleLoginRequest.serializer())
            .response(DAuth.serializer())
    }

    override suspend fun refresh(token: String): DResponse<DAuth> {
        return this.api.consume("$resourcePath/token/refresh/")
            .post(DRefreshRequest(token), DRefreshRequest.serializer())
            .response(DAuth.serializer())
    }

    override suspend fun logout(email: String): DResponse<Nothing> {
        return this.api.consume("$resourcePath/logout/")
            .post(email, String.serializer())
            .response(null)
    }

    override suspend fun register(name: String, email: String, pass: String): DResponse<DAuth> {
        return this.api.consume("$resourcePath/register/")
            .post(link.erpango.quip.domain.entities.DRegisterRequest(name, email, pass), link.erpango.quip.domain.entities.DRegisterRequest.serializer())
            .response(DAuth.serializer())
    }

    override suspend fun registerDevice(token: String, platform: String, deviceId: String?): DResponse<Unit> {
        return this.api.consume("api/notifications/register-device/")
            .post(
                link.erpango.quip.domain.entities.DDeviceRegisterRequest(token, platform, deviceId),
                link.erpango.quip.domain.entities.DDeviceRegisterRequest.serializer()
            )
            .response(null)
    }

    override suspend fun fetchNotificationSettings(): DResponse<link.erpango.quip.domain.entities.DNotificationSettingsRequest> {
        return this.api.consume("api/notifications/settings/")
            .get()
            .response(link.erpango.quip.domain.entities.DNotificationSettingsRequest.serializer())
    }

    override suspend fun updateNotificationSettings(maintenance: Boolean, itv: Boolean, revision: Boolean, sparePart: Boolean): DResponse<Unit> {
        return this.api.consume("api/notifications/settings/")
            .put(
                link.erpango.quip.domain.entities.DNotificationSettingsRequest(maintenance, itv, revision, sparePart),
                link.erpango.quip.domain.entities.DNotificationSettingsRequest.serializer()
            )
            .response(null)
    }
}